import { Flex, FlexProps } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';
import './Page.css';

const Page: FunctionComponent<FlexProps> = (props) => <Flex {...props} direction="vertical" grow />;

export default Page;
